import useSWRMutation from 'swr/mutation';

import CameraConnection from 'src/models/Camera/CameraConnection';
import { SWRKeysEnum } from 'src/models/SWRKeys.model';

export function useContinueCaptureProcess() {
  const { data, error, trigger, isMutating } = useSWRMutation(
    SWRKeysEnum.CONTINUE_CAPTURE_PROCESS,
    () => CameraConnection.getInstance().continueCaptureProcess(),
  );

  return {
    continueResponse: data?.data,
    isMutating,
    isError: error,
    continueCaptureProcess: trigger,
  };
}
